<template>
  <div>
    <v-container id="intro" class="text-center" v-show="showIntro">
      <background1></background1>

      <h1>Kanji Game</h1>
      <h4>Gioca contro il tempo</h4>
      <h3>La sfida di questa sezione è..</h3>
      <h2 class="text-xs-center">{{ intro }}</h2>
      <v-checkbox
        v-model="enmusic"
        type="checkbox"
        id="audiosetting"
        color="white"
        width="100"
        height="50"
        class="audiosetting"
        label="music on"
      ></v-checkbox>
      <!--
        <v-form class="input-wrapper" v-model="isFormValid">
        <div class="input-element">
          <v-text-field class="deep" label="Il tuo nick qui" v-model="name" :rules="rules"></v-text-field>
        </div>
        </v-form>-->
      <div class="login-block" v-if="!isLogged">
        <v-btn x-large color="primary" @click="openShibo">LOGIN</v-btn>
      </div>
      <div class="login-block" v-else>
        Sei collegato come:<br />{{ $store.getters.getName }}
        <v-btn x-small color="secondary" @click="setLogout">logout</v-btn>
      </div>

      <v-btn
        color="primary"
        elevation="20"
        x-large
        @click="start"
        :disabled="!isLogged"
        >INIZIA</v-btn
      >

      <img id='qrcode' src="@/assets/qrcode.svg" alt="QR code per accedere al gioco">
    </v-container>
    <v-footer app class="mt-8 intro-footer">
      <v-card class="text-center" flat width="100%" color="transparent">
        Ricerca e sviluppo di Alessandro Mantelli, Dipartimento di Studi
        sull'Asia e l'Africa Mediterranea, Università Ca' Foscari Venezia
      </v-card>
    </v-footer>
  </div>
</template>

<script>
import Cookies from "js-cookie";

import { data, intro } from "./data1";
import background1 from "./background";
import utils from "./utils";
import CryptoJSAesJson from "./crypto";
import CryptoJS from "crypto-js";
export default {
  name: "introPanel",
  props: ["showIntro"],
  data() {
    return {
      rules: [
        (value) => !!value || "Obbligatorio",
        (value) =>
          (value && value.length == 8) || "Metti un nick di 8 caratteri",
      ],
      name: this.$store.getters.getName,
      enmusic: false,
      intro: intro,
      isFormValid: false,
      source: "https://a4edu.unive.it/secure/auth-spa.php",
      shiboParams: "",
      isLogged: false,
      dismusic: false,
    };
  },
  components: {
    background1,
  },

  mounted() {
    //utils.saveData();
    console.log(this.$store.getters.getName);
    const url = window.location.href;
    const paramName = "?shibo-params=";
    if (url.indexOf(paramName) > -1) {
      const aSplit = url.split(paramName);
      const newUrl = aSplit[0];
      let params = decodeURIComponent(aSplit[1]);
      let stringed = "";
      params.split("|").forEach((a) => {
        stringed += String.fromCharCode(a);
      });

      const decodeParams = CryptoJS.AES.decrypt(stringed, "cardgame", {
        format: CryptoJSAesJson,
      }).toString(CryptoJS.enc.Utf8);
      const shiboParams = JSON.parse(decodeParams);
      this.shiboParams = shiboParams;
      if (typeof shiboParams == "object") {
        history.pushState(null, null, newUrl);
        Cookies.set(
          "intro_params",
          JSON.stringify({
            name: shiboParams.Shib_cn,
            mail: shiboParams.Shib_mail,
          })
        );
        Cookies.set("setMail", shiboParams.Shib_mail);
        this.isLogged = true;
      }
    }
    const inCk = Cookies.get("intro_params");
    if (inCk) {
      const incka = JSON.parse(inCk);
      this.$store.commit("setName", incka.name);
      this.$store.commit("setMail", incka.mail);
    }
    this.isLogged =
      this.$store.getters.getName && this.$store.getters.getMail ? true : false;
    if (this.isLogged == true) {
      //this.recTest(this.$store.getters.getName, this.$store.getters.getMail);
    }
  },
  watch: {
    enmusic(val1) {
      this.$emit("completed", false, val1);
      this.dismusic = val1;
    },
  },
  methods: {
    start() {
      //this.$store.commit('setName',this.name);
      // console.log("---",this.$store.getters.getName);
      this.hideIntro = true;
      this.$emit("completed", true, this.dismusic);
    },
    openShibo() {
      let callback = "";
      if (process.env.NODE_ENV != "production") {
        callback = "?test-url=http://localhost:8080/cardgame";
      }
      const urlToCall =
        "https://a4edu.unive.it/secure/auth-cardgame.php" + callback;
      location.href = urlToCall;
    },
    setLogout() {
      this.isLogged = false;
      this.$store.commit("setName", "");
      this.$store.commit("setMail", "");
      Cookies.remove("intro_params");
    },
    recTest(fullname, email, scores) {
      const dummyScores = [
        {
          givenAnswer: "ついたち",
          correctAnswer: "ふつか",
          score: 0,
          timer: 2.1,
        },
        {
          givenAnswer: "みっか",
          correctAnswer: "みっか",
          score: 1,
          timer: 3.1,
        },
      ];
      if (typeof scores == "undefined") {
        scores = dummyScores;
      }
      if (this.isLogged == true) {
        utils.saveData(fullname, email, scores).then(() => {
          console.log("aaaaa");
        });
      }
    },
  },
};
</script>

<style scoped>
#intro {
  font-family: "Press Start 2P", cursive;
}

#intro h1 {
  color: #f35c5c;
  font-family: 'Press Start 2P', cursive;
  font-size:36px;
}
#intro h4 {
  margin-top: 16px;
  color: yellow;
}
#intro h3 {
  color: white;
  margin-top: 24px;
}
#intro h2 {
  margin: 32px;
  color: lightgreen;
}
.audiosetting {
  color: white;
  transform: scale(1.3);
  width: fit-content;
  padding: 0;
  margin: 0 auto;
}
.input-wrapper {
  display: flex;
  justify-content: center;
}
.input-element {
  width: 350px;
  text-align: center;
}
.s-style {
  width: 600px;
  height: 400px;
}
.login-block {
  margin-bottom: 32px;
}
.intro-footer {
  background: none;
  text-align: center;
  font-weight: bold;
}
#qrcode {
  display:block;
  width:150px;
  text-align:center;
  margin:0 auto;
  margin-top:24px;
}
</style>